import { VERSION } from './version.token';

export const provideVersion = (version: string) => ({
    provide: VERSION,
    useValue: version,
});
